import { ToggleControl } from '@wordpress/components'
import { useDispatch, useSelect } from '@wordpress/data'
import { store as editorStore } from '@wordpress/editor'

const MetaToggle = ({ state, fieldName }) => {
  const metaFieldValue = useSelect(
    select => select(editorStore).getEditedPostAttribute('meta')[fieldName],
    []
  )

  const setMetaFieldValue = useDispatch(editorStore).editPost

  return (
    <ToggleControl
      checked={metaFieldValue}
      onChange={content => setMetaFieldValue({ meta: { [fieldName]: !!content } })}
      label={metaFieldValue ? 'Yes' : 'No'}
    />
  )
}

export default MetaToggle
